import React from 'react';
import { useI18n } from '@monorepo/i18n';
import { TotalCountCommon } from '@monorepo/common';
import useGetFastDeals from '../../hooks/useGetFastDeals';

const TotalCount = () => {
  const { data, getTotalCount } = useGetFastDeals();
  const { t } = useI18n();

  if (!data) {
    return null;
  }

  return (
    <TotalCountCommon
      count={getTotalCount(data)}
      title={t('dealstotalcount.title')}
    />
  );
};

export default TotalCount;
